import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFundedTradersStatus } from "../../api/service/index.types";

export interface IFundedTradersStatusesListState {
  data: {
    fundedTradersStatusesList: IFundedTradersStatus[];
  };
  loading: boolean;
}

export const initialState: IFundedTradersStatusesListState = {
  data: {
    fundedTradersStatusesList: [],
  },
  loading: true,
};

const index = createSlice({
  name: "fundedTradersStatusesList",
  initialState,
  reducers: {
    fetchListRequest: (state) => {
      state.loading = true;
    },
    fetchListSuccess: (state, action: PayloadAction<IFundedTradersStatus[]>) => {
      state.data.fundedTradersStatusesList = action.payload;
      state.loading = false;
    },
    fetchListFailed: (state) => {
      state.loading = false;
    },
  },
});

export const fundedTradersStatusesListActions = index.actions;
export default index.reducer;
